import ImageIcon from '@mui/icons-material/Image';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FileThumbnailService } from 'utilities/files/file-thumbnail-service';

type JSFile = File;

const fileThumbnailService = new FileThumbnailService();

const getFileIcon = (file: JSFile) => {
  switch (file.type) {
    case 'image':
      return <ImageIcon />;
    case 'video':
      return <OndemandVideoIcon />;
    case 'audio':
      return <VolumeUpIcon />;
    default:
      return <InsertDriveFileIcon />;
  }
};

const ThumbnailWrapperSpan = styled.span`
  height: 38px;
  width: 56px;
  overflow: hidden;
  display: inline-block;

  img {
    height: 100%;
    max-width: 56px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const FileThumbnail = ({ file }: { file: JSFile }) => {
  const [thumbnailData, setThumbnailData] = useState<string | ArrayBuffer>(
    null
  );

  useEffect(() => {
    fileThumbnailService.getThumbnail(file).then(thumbnail => {
      setThumbnailData(thumbnail);
    });
  }, [file]);

  if (!thumbnailData) {
    return <ThumbnailWrapperSpan>{getFileIcon(file)}</ThumbnailWrapperSpan>;
  }
  return (
    <ThumbnailWrapperSpan>
      <img src={thumbnailData.toString()} />
    </ThumbnailWrapperSpan>
  );
};
